function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "add-white_svg__a",
  width: "528.6%",
  height: "528.6%",
  x: "-214.3%",
  y: "-128.6%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 24,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0307687953 0"
}), React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2",
  values: "0 0 0 0 0.42745098 0 0 0 0 0.521568627 0 0 0 0 0.619607843 0 0 0 0.0842108243 0"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))), React.createElement("circle", {
  id: "add-white_svg__b",
  cx: 14,
  cy: 14,
  r: 14
}), React.createElement("path", {
  id: "add-white_svg__c",
  d: "M7.5 5.833h5a.833.833 0 010 1.667h-5v5a.833.833 0 11-1.667 0v-5h-5a.833.833 0 110-1.667h5v-5a.833.833 0 011.667 0v5z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#F8FBFD",
  d: "M-1095-584H505v960h-1600z"
}), React.createElement("path", {
  d: "M0 0h28v28H0z"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#add-white_svg__a)",
  xlinkHref: "#add-white_svg__b"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#add-white_svg__b"
}), React.createElement("g", {
  transform: "translate(7.333 7.333)"
}, React.createElement("mask", {
  id: "add-white_svg__d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#add-white_svg__c"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#add-white_svg__c"
}), React.createElement("g", {
  fill: "#22272F",
  mask: "url(#add-white_svg__d)"
}, React.createElement("path", {
  d: "M-3.333-3.333h20v20h-20z"
}))));

var SvgAddWhite = function SvgAddWhite(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/add-white.8c8dde34.svg";
export { SvgAddWhite as ReactComponent };